module.exports = __webpack_public_path__ + "static/img/iphone_room4.01a1e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_room4.png
// module id = bYJE
// module chunks = 0